let debugBox = document.getElementById('debug-box');

export function debugLog(msg: string) {
  console.log(msg);
  if (!debugBox) return;
  const line = `[${new Date().toISOString().slice(11, 23)}] ${msg}`;
  debugBox.textContent += line + '\n';
  debugBox.scrollTop = debugBox.scrollHeight;
}

export function debugClear() {
  if (debugBox) debugBox.textContent = '';
}

export function setDebugOverlayVisibility(visible: boolean) {
  if (debugBox) debugBox.style.display = visible ? 'block' : 'none';
}
